import React from "react";
import PropTypes from "prop-types";

function TextInput(props) {
    let wrapperClass = "row mb-2";
    if (props.error.length > 0) {
        wrapperClass += " has-error";
    }

    let labelClass = "col-form-label "
    let inputClass = "";
    let labelSize = props.label.length;
    if (labelSize >= 25 && labelSize < 40) {
        labelClass += "col-sm-5 col-lg-3";
        inputClass = "col-sm-8 col-lg-3";
    }
    else if (labelSize >= 40) {
        labelClass += "col-sm-6 col-lg-4";
        inputClass = "col-sm-8 col-lg-2";
    }
    else {
        labelClass += "col-sm-3 col-lg-2";
        inputClass = "col-sm-8 col-lg-4";
    }

    function handleChange(event) {
        let isValid = true;//if the value is valid according to its datatype, for now is only been used with int and float
        let value;
        if (props.dataType === "int") {
            value = event.target.value;
            if (!isNaN(value) && Number.isInteger(Number(value)))
                value = Number(value);
            else
                isValid = false;
        }
        else if (props.dataType === "float") {
            value = event.target.value;
            if (value.endsWith(".") || isNaN(value)) {
                //TO DO: see if knowing that the float number is not valid while typing can be used for something
                //isValid = false;//commented because is not valid now but might be later
            }
            else
                value = Number(value);
        }
        else if (props.dataType === "check")
            value = event.target.checked;
        else
            value = event.target.value;

        props.onChange(event, props.dataType, props.id, value, isValid);
    }

    function handleLostFocus(event) {
        let isValid = true;
        let value;
        let expectNumber = false;
        if (props.dataType === "int") {
            value = parseInt(event.target.value);
            expectNumber = true;
        }
        else if (props.dataType === "float") {
            value = parseFloat(event.target.value);
            expectNumber = true;
        }

        if (expectNumber) {
            if (isNaN(value)) {
                value = 0;
                isValid = false;
            }
            props.onChange(event, props.dataType, props.id, value, isValid);
        }
    }

    return (
        <div className={wrapperClass}>
            <label className={labelClass} htmlFor={props.id}>
                {props.label}
            </label>
            <div className={inputClass}>
                <input
                    id={props.id}
                    type={props.dataType === "float" || props.dataType === "int" ? "number" : "text"}
                    className="form-control"
                    value={props.value}
                    onChange={event => {
                        handleChange(event);
                    }}
                    onBlur={event => {
                        handleLostFocus(event);
                    }}
                    step={props.step ? props.step : (props.dataType === "float" ? "0.01" : null) }// a null value omits the attribute when rendering
                    autoComplete="off"
                    minLength={props.minLength}
                    maxLength={props.maxLength}
                    min={props.min}
                    max={props.max}
                    required={props.required}
                />
            </div>
            {props.error && <div className="alert alert-danger">{props.error}</div>}
        </div>
    );
}

TextInput.propTypes = {
    dataType: PropTypes.string,
    error: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any
};

TextInput.defaultProps = {
    dataType: "",
    error: ""
};

export default TextInput;
